import axios from "axios";

export const FETCH_BILLING_URL_REQUEST = "paymentPlan/FETCH_BILLING_URL";
export const FETCH_BILLING_URL_SUCCESS = "paymentPlan/FETCH_BILLING_URL_SUCCESS";
export const FETCH_BILLING_URL_FAILURE = "paymentPlan/FETCH_BILLING_URL_FAILURE";

const initialState = {
    loading: false,
    confirmationUrl: null,
    errorMessage: null,
};

export default (state = initialState, action) => {
    switch (action.type) {
    case FETCH_BILLING_URL_REQUEST:
        return {
            ...state,
            loading: true,
            errorMessage: null,
        };
    case FETCH_BILLING_URL_FAILURE:
        return {
            ...state,
            loading: false,
            errorMessage: action.payload,
        };
    case FETCH_BILLING_URL_SUCCESS:
        return {
            ...state,
            loading: false,
            confirmationUrl: action.payload,
        };
    default:
        return state;
    }
};

const billingUrl = "/api/shop-billing-confirmation-url";

export const fetchBillingUrlRequest = () => {
    return {
        type: FETCH_BILLING_URL_REQUEST,
    };
};

export const fetchBillingUrlSuccess = (data) => {
    return {
        type: FETCH_BILLING_URL_SUCCESS,
        payload: data,
    };
};

export const fetchBillingUrlFailure = (error) => {
    return {
        type: FETCH_BILLING_URL_FAILURE,
        payload: error,
    };
};

export const getBillingUrl = planId => {

    return async (dispatch) => {
        dispatch(fetchBillingUrlRequest());
        try {
            const response = await axios.get(`${billingUrl}/${planId}`);
            console.log(response.data);
            dispatch(fetchBillingUrlSuccess(response.data));
        } catch (error) {
            dispatch(fetchBillingUrlFailure(error.message));
        }
    };

    // const requestUrl = `${billingUrl}/${planId}`;
    // return {
    //     type: FETCH_BILLING_URL_REQUEST,
    //     payload: axios.get(requestUrl),
    // };
};
